// extracted by mini-css-extract-plugin
export default {"Divider":"VoQSRLWL","Vertical":"XMYib3gR"};